import { AbstractDTO } from "./abstract";
import { IOrder } from "@signature-it/ngx-generic/interfaces";
/**
 * Created by shani on 28/11/17.
 */

export class OrdersDTO extends AbstractDTO implements IOrder{
    id:  number;
    parent_line_id: number;
    order_time: string;
    user_id: number;
    guest_user_id: string;
    product_id: number;
    asm_data: string;
    asm_param: string;
    quantity: number;
    price_per_items: number;
    asm_quantity: number;
    product_price: number;
    product_price_currency: string;
    uom: string;
    type: string;
    status: string;
    final_order_id: number;
    temporary_transaction_number: string;

    constructor(attributes: object) {
        super(attributes);
        attributes = attributes ? attributes : {};

        this.id =  attributes['id'] || 0;
        this.parent_line_id = attributes['parent_line_id'] || 0;
        this.order_time = attributes['order_time'] || "";
        this.user_id = attributes['user_id'] || 0;
        this.guest_user_id = attributes['guest_user_id'] || "";
        this.product_id = attributes['product_id'] || 0;
        this.asm_data = attributes['asm_data'] || "";
        this.asm_param = attributes['asm_param'] || "";
        this.quantity = attributes['quantity']|| 0;
        this.price_per_items = attributes['price_per_items'] || 0;
        this.asm_quantity = attributes['asm_quantity'] || 0;
        this.product_price = attributes['product_price'] || 0;
        this.product_price_currency = attributes['product_price_currency'] || "";
        this.uom = attributes['uom'] || "";
        this.type = attributes['type'] || "";
        this.status = attributes['status'] || "";
        this.final_order_id = attributes['final_order_id'] || 0 ;
        this.temporary_transaction_number = attributes['temporary_transaction_number'] ||  "";
    }

}
